import { Component } from '@angular/core';
import { MaliciousComponent } from 'app/components/malware/malicious/malicious.component';
import { BackupSystemsService } from 'app/services/backup-systems';
import { MaliciousFileStatus } from '@imunify360-api/malicious';
import { ResourceType } from '@imunify360-api/malware';

@Component({
    selector: 'i360-restore-from-backup-malicious-action',
    template: `
        <i360-action
                *ngIf="backupSystemsService.backupsEnabled | async"
                [filter]="{status: status, resource_type: ResourceType.file}"
                title="actions.tryToRestore"
                (perform)="malicious.changeItems('restore-from-backup', $event)">
        </i360-action>
    `,
})
export class RestoreFromBackupActionComponent {
    ResourceType = ResourceType;
    status = [
        MaliciousFileStatus.quarantined,
        MaliciousFileStatus.found,
    ];
    constructor(public malicious: MaliciousComponent,
                public backupSystemsService: BackupSystemsService) {}
}
